import instance from "./ApiServices";
import authHeader from "./auth-header";

const getAll = () => {
  return instance.get("/menucategories", { headers: authHeader() });
};

const get = (id) => {
  return instance.get(`/menucategory/${id}`, { headers: authHeader() });
};

const create = (data) => {
  return instance.post("/menucategory", data, { headers: authHeader() });
};

const update = (id, data) => {
  return instance.post(`/menucategory/${id}?_method=PUT`, data, {
    headers: authHeader(),
  });
};

const remove = (id) => {
  return instance.delete(`/menucategory/${id}`, { headers: authHeader() });
};

const removeAll = () => {
  return instance.delete(`/menucategory`);
};

const findByTitle = (title) => {
  return instance.get(`/menucategory?title=${title}`);
};

const MenuCategoriesService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default MenuCategoriesService;
